<template>
    <div class="airports-map-container">
        <div ref="map"></div>
    </div>
</template>

<script>
export default {
    props: {
        airportsData: String,
    },
    data() {
        return {
            airports: [],
            map: null,
        };
    },
    mounted() {
        this.airports = JSON.parse(this.airportsData);
        this.map = L.map(this.$refs.map, {
            scrollWheelZoom: false,
            dragging: !L.Browser.mobile,
            tap: !L.Browser.mobile
        });
        L.tileLayer(this.$root.mapConfig.url, {
            maxZoom: 13,
            attribution: this.$root.mapConfig.attribution,
        }).addTo(this.map);
        var markers = L.markerClusterGroup();
        this.airports.forEach((airport) => {
            if (!!airport.latitudeLongitude) {
                let marker = L.marker(airport.latitudeLongitude.coordinates, {
                    icon: this.$root.mapConfig.icon,
                });
                markers.addLayer(marker);
                let label = Vue.i18n.translate("pages.seo.airports.map-label", {
                    airportName: airport.ville
                        ? airport.ville
                        : airport.nomAeroport,
                    href: airport.details_url,
                });
                marker.bindPopup(L.popup().setContent(label));
            }
        });
        markers.addTo(this.map);
        this.map.setView(this.$root.mapConfig.defaultCenter, 4);
    },
};
</script>

<style lang="scss" scoped>
.leaflet-container {
    width: 100%;
    height: 500px;
}
</style>


// WEBPACK FOOTER //
// resources/assets/js/components/AirportsMap.vue